import React from 'react'
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { get } from 'lodash';
import { user as userIcon } from 'react-icons-kit/icomoon/user';
import { menu as menuIcon } from 'react-icons-kit/icomoon/menu';
import {lifebuoy} from 'react-icons-kit/icomoon/lifebuoy'
import { getUser, getTeamUrl, getCurrentTeam, getTeams, goToTeam, isAdmin, isPaymentUser } from 'Common';
import { createPermitFunction } from '../Evolve/Utilities/permissions';

const currentTeam = getCurrentTeam()

const selectPathname = state => state.router.location.pathname;
const selectUserPermissions = state => (state.user && state.user.permissions) || [];

const user = getUser()

export default createSelector(
  selectPathname,
  selectUserPermissions,
  (pathname, userPermissions) => {

    const permit = createPermitFunction(userPermissions);

    const showButton = key => {
      if (!user) return false;

      // Super users see all menu items except subcontractor-only ones
      if (!!user.is_super) {
        const subcontractorOnlyButtons = ['my_orders', 'rams_signing', 'tbt_signing', 'timesheet_posting'];
        return !subcontractorOnlyButtons.includes(key);
      }

      // Non-super users need the matching menu permission
      return userPermissions.includes('menu_' + key);
    }

    const left = [
      {
        key: "dashboard",
        id: "dashboard",
        className: "dashboard",
        title: 'Dashboard',
        href: getTeamUrl('dashboard'),
        selected: pathname && pathname.startsWith(getTeamUrl('dashboard')),
        show: showButton('dashboard'),
      },
      {
        key: "projects",
        title: 'Projects',
        href: getTeamUrl('projects'),
        selected: pathname && pathname.startsWith(getTeamUrl('projects')),
        show: showButton('projects'),
      },
      {
        key: "estimates",
        title: 'Estimates',
        href: getTeamUrl('estimates'),
        selected: pathname && pathname.startsWith(getTeamUrl('estimates')),
        show: showButton('estimates'),
      },
      {
        key: "orders",
        title: 'Orders',
        href: getTeamUrl('orders'),
        selected: pathname && pathname.startsWith(getTeamUrl('orders')),
        show: showButton('orders'),
      },
      {
        key: "valuations",
        title: 'Valuations',
        href: getTeamUrl('valuations'),
        selected: pathname && pathname.startsWith(getTeamUrl('valuations')),
        show: showButton('valuations'),
      },
      {
        key: "invoices",
        title: 'Invoices',
        href: getTeamUrl('invoices'),
        selected: pathname && pathname.startsWith(getTeamUrl('invoices')),
        show: showButton('invoices'),
      },
      {
        key: "retention_payments",
        title: 'Retentions',
        href: getTeamUrl('retention_payments'),
        selected: pathname && pathname.startsWith(getTeamUrl('retention_payments')),
        show: showButton('retention_payments'),
      },
      {
        key: "rams_records",
        title: 'RAMS',
        href: getTeamUrl('rams'),
        selected: pathname && (pathname.startsWith(getTeamUrl('rams')) && !pathname.startsWith(getTeamUrl('rams-signing')) && !pathname.startsWith(getTeamUrl('rams_records'))),
        show: showButton('rams_records'),
      },
      {
        key: "clients",
        title: 'Clients',
        href: getTeamUrl('clients'),
        selected: pathname && pathname.startsWith(getTeamUrl('clients')),
        show: showButton('clients'),
      },
      {
        key: "suppliers",
        title: 'Suppliers',
        href: getTeamUrl('suppliers'),
        selected: pathname && pathname.startsWith(getTeamUrl('suppliers')),
        show: showButton('suppliers'),
      },
      {
        key: "subcontractors",
        title: 'Subcontractors',
        href: getTeamUrl('subcontractors'),
        selected: pathname && (
          pathname.startsWith(getTeamUrl('subcontractors')) ||
          pathname.startsWith(getTeamUrl('sub_projects')) ||
          pathname.startsWith(getTeamUrl('sub_orders')) ||
          pathname.startsWith(getTeamUrl('sub_valuations')) ||
          pathname.startsWith(getTeamUrl('sub_invoices'))
        ),
        show: showButton('subcontractors'),
      },
      {
        key: "planner",
        title: 'Planner',
        href: getTeamUrl('planner'),
        selected: pathname && pathname.startsWith(getTeamUrl('planner')),
        show: showButton('planner'),
      },
      // {
      //   key: "timesheet_posting",
      //   title: 'Time Entry',
      //   href: getTeamUrl('timesheet_posting'),
      //   selected: pathname && pathname.startsWith(getTeamUrl('timesheet_posting')),
      //   show: showButton('timesheet_posting'),
      // },
      {
        key: "timesheets",
        title: 'Timesheets',
        href: getTeamUrl('timesheets'),
        selected: pathname && pathname.startsWith(getTeamUrl('timesheets')),
        show: showButton('timesheets'),
      },
      {
        key: "profit_and_loss",
        title: 'Profit & Loss',
        href: getTeamUrl('profit_and_loss'),
        selected: pathname && pathname.startsWith(getTeamUrl('profit_and_loss')),
        show: showButton('profit_and_loss'),
      },
      {
        key: "toolbox_talks",
        title: 'Tool Box Talks',
        href: getTeamUrl('toolbox_talks'),
        selected: pathname && pathname.startsWith(getTeamUrl('toolbox_talks')),
        show: showButton('toolbox_talks'),
      },
      {
        key: "insights",
        title: 'Insights',
        href: getTeamUrl('insights'),
        selected: pathname && pathname.startsWith(getTeamUrl('insights')),
        show: showButton('insights'),
      },
        {
            key: "my_orders",
            id: "my_orders",
            className: "my_orders",
            title: 'My Orders',
            href: getTeamUrl('my-orders'),
            selected: pathname && pathname.startsWith(getTeamUrl('my-orders')),
            show: showButton('my_orders'),
        },
        {
            key: "rams_signing",
            id: "rams_signing",
            className: "rams_signing",
            title: 'RAMS',
            href: getTeamUrl('rams-signing'),
            selected: pathname && pathname.startsWith(getTeamUrl('rams-signing')),
            show: showButton('rams_signing'),
        },
        {
            key: "tbt_signing",
            id: "tbt_signing",
            className: "tbt_signing",
            title: 'Tool Box Talks',
            href: getTeamUrl('tbt-signing'),
            selected: pathname && pathname.startsWith(getTeamUrl('tbt-signing')),
            show: showButton('tbt_signing'),
        },
        {
            key: "timesheet_posting",
            id: "timesheet_posting",
            className: "timesheet_posting",
            title: 'Timesheets',
            href: getTeamUrl('timesheet_posting'),
            selected: pathname && pathname.startsWith(getTeamUrl('timesheet_posting')),
            show: showButton('timesheet_posting'),
        },
    ].filter(button => button.show)

    let usertype = "";
    if (user !== undefined)
	  usertype = user.type;

    const teams = getTeams();

    const right = [
        {
            icon: lifebuoy,
            key: "knowledgebase",
            title: 'Help',
            target: '_new',
            hreffull: "https://leadpm.cloud/help/",
            show: showButton('knowledgebase'),
        },
        {
            key: "logout",
            title: "logout-menu-" + usertype,
            show: true,
            icon: userIcon,
            dropdown: (
                <Menu selectedKeys={[get(currentTeam, 'slug')]} style={{minWidth: 160}} show={true}>
                    {isPaymentUser() && (<Menu.Item key='billing'>
                        <Link to={getTeamUrl('billing')}>Billing</Link>
                    </Menu.Item>)}
                    {(showButton('settings') && isAdmin() && permit('settings_admin')) && (<Menu.Item key='settings'>
                        <Link to={getTeamUrl('settings')}>Settings</Link>
                    </Menu.Item>)}
                    {showButton('emails') && (<Menu.Item key='emails'>
                        <Link to={getTeamUrl('emails')}>Emails</Link>
                    </Menu.Item>)}
                    {(showButton('users') && isAdmin() && (permit('user_admin') || permit('user_edit'))) && (
                        <Menu.Item key='users' selected={pathname && pathname.startsWith(getTeamUrl('users'))}>
                            <Link to={getTeamUrl('users')}>Users</Link>
                        </Menu.Item>)}
                    {!!teams.length && (
                        <React.Fragment>
                            <Menu.ItemGroup title='Teams'>
                                {teams.map(team => (
                                    <Menu.Item
                                        key={team.slug}
                                        onClick={() => goToTeam(team)}
                                    >
                                        {team.name}
                                    </Menu.Item>
                                ))}
                            </Menu.ItemGroup>
                        </React.Fragment>
                    )}
                    <React.Fragment>
                        <Menu.Divider/>
                    </React.Fragment>
                    <Menu.Item key='logout'>
                        <Link to='/logout'>Logout</Link>
                    </Menu.Item>
                </Menu>
            ),
        },
        {
            key: "mobile",
            title: "mobile-menu-" + usertype,
            show: true,
            icon: menuIcon,
            dropdown: (
                <Menu selectedKeys={[pathname]} style={{minWidth: 160}} show={true}>
                    {!!left.length && (
                        <React.Fragment>
                            {left.map(submenu => (
                                <Menu.Item
                                    key={submenu.key}
                                >
                                    <Link to={submenu.href}>{submenu.title}</Link>
                                </Menu.Item>
                            ))}
                        </React.Fragment>
                    )}
                </Menu>
            ),
        }
    ].filter(button => button.show)

    return {
      left,
      right,
    };
  }
)



